import { Alert } from '@apex/component-library'
import React from 'react'

type TransferAmountProps = {
  transferAmount: number
  amountAvailable: number
}

const TransferAmountWarning = ({ transferAmount, amountAvailable }: TransferAmountProps) => {
  const hasWarning = transferAmount > amountAvailable

  return hasWarning ? (
    <Alert
      status='warning'
      title={'Transfer amount is greater than amount available.'}
      description={'Make sure you want to proceed before confirming.'}
      showIcon
      direction='column'
      className='test-id-transfer-amount-alert'
    />
  ) : null
}

export default TransferAmountWarning
